export const mutations = {
  ANALYTIC_ATTACH: "ANALYTIC_ATTACH",
  ANALYTIC_ADD_VARIANTS_ATTACH: "ANALYTIC_ADD_VARIANTS_ATTACH",
  ANALYTIC_UPDATE_PERCENT_ATTACH: "ANALYTIC_UPDATE_PERCENT_ATTACH",
  ANALYTIC_FETCH_NEW: "ANALYTIC_FETCH_NEW",
  ANALYTIC_FETCH: "ANALYTIC_FETCH",
  ANALYTIC_APPEND: "ANALYTIC_APPEND",
  ANALYTIC_UPDATE_CAMPAIGN: "ANALYTIC_UPDATE_CAMPAIGN",
  ANALYTIC_UPDATE_CAMPAIGN_STATUS: "ANALYTIC_UPDATE_CAMPAIGN_STATUS",
  ANALYTIC_UPDATE_CAMPAIGN_INDICATING: "ANALYTIC_UPDATE_CAMPAIGN_INDICATING",
  ANALYTIC_DELETE_CAMPAIGN: "ANALYTIC_DELETE_CAMPAIGN",
  ANALYTIC_DELETE_CAMPAIGN_VARIANT: "ANALYTIC_DELETE_CAMPAIGN_VARIANT",
  ANALYTIC_UPDATE_CAMPAIGN_VARIANT: "ANALYTIC_UPDATE_CAMPAIGN_VARIANT",
  ANALYTIC_FETCH_ACCOUNTS: "ANALYTIC_FETCH_ACCOUNTS",
};

export const actions = {
  FETCH_ANALYTIC: "fetchAnalytic",
  FETCH_DETAIL_ANALYTIC: "fetchDetailAnalytic",
  CREATE_NEW_CAMPAIGN_ANALYTIC: "createNewCampaignAnalytic",
  DELETE_CAMPAIGN_ANALYTIC: "deleteCampaignAnalytic",
  START_CAMPAIGN_ANALYTIC: "startCampaignAnalytic",
  STOP_CAMPAIGN_ANALYTIC: "stopCampaignAnalytic",
  TOGGLE_CAMPAIGN_ANALYTIC: "toggleCampaignAnalytic",
  UPDATE_CAMPAIGN_ANALYTIC: "updateCampaignAnalytic",
  ADD_VARIANTS_ANALYTIC: "addVariantsAnalytic",
  UPDATE_PERCENTS_ANALYTIC: "updatePercentsAnalytic",
  DELETE_VARIANT_ANALYTIC: "deleteVariantAnalytic",
  UPDATE_VARIANT_ANALYTIC: "updateVariantAnalytic",
  GET_REPORT_ANALYTIC: "getReportAnalytic",
  FETCH_ACCOUNTS_ANALYTIC: "fetchAccountsAnalytic",
  FETCH_PROPERTIES_ANALYTIC: "getPropertiesAnalytic",
  FETCH_PROFILES_ANALYTIC: "getProfilesAnalytic",
  FETCH_STREAMS_ANALYTIC: "getStreamsAnalytic",
  CLONE_PAGE_ANALYTIC: "clonePageAnalytic",


};
